import { API_BASE_URL, API_ENDPOINTS } from '../config/api';
import { api } from '../utils/apiClient';
import type {
  GetNotificationPreferencesResponse,
  UpdateNotificationPreferencesRequest,
  UpdateNotificationPreferencesResponse
} from '../types/notification';

/**
 * Get user notification preferences
 * Requires authentication (token automatically included)
 */
export const getNotificationPreferences = async (): Promise<GetNotificationPreferencesResponse> => {
  return api.get<GetNotificationPreferencesResponse>(
    `${API_BASE_URL.CAMPAIGN}${API_ENDPOINTS.NOTIFICATION.GET_PREFERENCES}`
  );
};

/**
 * Update user notification preferences
 * Requires authentication (token automatically included)
 */
export const updateNotificationPreferences = async (
  preferences: UpdateNotificationPreferencesRequest
): Promise<UpdateNotificationPreferencesResponse> => {
  return api.put<UpdateNotificationPreferencesResponse>(
    `${API_BASE_URL.CAMPAIGN}${API_ENDPOINTS.NOTIFICATION.UPDATE_PREFERENCES}`,
    preferences
  );
};

